import { render, staticRenderFns } from "./BaseSingleSelect.vue?vue&type=template&id=1da35a5c"
import script from "./BaseSingleSelect.vue?vue&type=script&lang=js"
export * from "./BaseSingleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports